import type { SupportedLocaleType } from '../locales/supported-locales';
import { buildEnglishIqResultImgR2Key, validateEnglishIqResultImgSlug } from './english-iq';
import { getChallengeShard } from './get-challenge-shard';
import type { ImgTypeType } from './img-types';

export interface IBuildImgArgs {
  type: ImgTypeType;
  slug: string;
  locale: SupportedLocaleType;
}

export function buildImgR2Key(args: IBuildImgArgs): string {
  if (args.type === 'english-iq-result') {
    if (!validateEnglishIqResultImgSlug(args.slug)) {
      throw new Error(`English IQ result image slug invalid: ${args.slug}`);
    }
    return buildEnglishIqResultImgR2Key({ score: Number(args.slug), locale: args.locale });
  }
  const filename = `${args.slug}-${args.locale}.png`;
  if (args.type === 'challenge') {
    return `challenge/${getChallengeShard(args.slug)}/${args.slug}/${filename}`;
  }
  if (args.type === 'collection') {
    return `collection/${args.slug}/${filename}`;
  }
  return `img/${args.type}/${args.slug}/${filename}`;
}
